.buttonGroup {
  background-color: var(--tuna-palette-background-paper);
  width: 50%;
  min-width: 350px;
}

.menuButton {
  padding-left: 8px;
  margin: 0;
  overflow: hidden;
  text-transform: none;
  width: 100%;
  border-radius: 0;
}

.navButton {
  margin: 0;
  overflow: hidden;
  text-transform: none;
  width: 100%;
  border-radius: 0;
}

/*
 * Stage-sized touch target: the nav is tapped mid-song on a tablet on a music stand,
 * so hold it to 48px (Material 48dp / Apple 44pt). Performance mode only; the ui-lib
 * Button sizes are unchanged. The content row reserves 64px at the bottom, so the
 * fixed nav still clears the page content.
 */
.stageTarget {
  min-height: var(--tuna-spacing-6);
}

.buttonText {
  white-space: nowrap;
  text-overflow: ellipsis;
  align-self: right;
  overflow: hidden;
}

.menuItem {
  padding: 8px 16px;
}
